<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <loading
        :active.sync="loader"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>

    <b-card class="bCardAgenda">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">Características categoría</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:right" class="textoSubtitulo">Config_categoria</p>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div class="mt-2"></div>

      <b-container fluid="">
        <b-row class="text-center mt-4">
          <b-col cols="1" md="3"></b-col>

          <b-col cols="9" md="6">
            <b-row class="contenedorTablaSinColor" style="background:white" v-if="$localStorageService.can('Config_categoria_buscar')">
              <b-col cols="10" lg="11" class="pr-0">
                <b-input-group class="pl-3">
                  <b-form-input
                      class="input-filter"
                      maxLength="15"
                      v-model="filtro.palabraClave"
                      type="search"
                      id="nombreBusq"
                      name="nombre"
                      responsive
                      placeholder="Búsqueda de característica"
                      @keydown.enter.native="obtenerCaracteristicasCategoria">
                  </b-form-input>
                </b-input-group>
              </b-col>
              <b-col cols="2" lg="1" class="pl-0">
                <b-button
                    class="mt-1 pb-1"
                    size="sm"
                    variant="info"
                    :disabled="loader"
                    responsive
                    @click="obtenerCaracteristicasCategoria"
                >
                <span v-if="!loader"
                >
                  <em class="buscar_svg primary sm"></em>
                </span>
                  <span v-else><b-spinner small></b-spinner></span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="1" class="text-left mt-auto mb-auto">
            <b-button
                v-if="$localStorageService.can('Config_categoria_crear')"
                variant="primary"
                v-b-tooltip.hover
                title="Alta de característica"
                class="paddingbotones2 botonesAzulFuerte"
                @click="agregar"
                responsive
            ><em class="herramienta_svg sm"></em>
            </b-button>
          </b-col>

          <div class="col-12">
            <b-row>
              <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
                <b-table
                    id="Pendientes"
                    thead-tr-class="columnasTablaSinColor"
                    :items="datosTabla"
                    :fields="fields"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    responsive="true"
                    fixed
                >
                  <template v-slot:cell(fechaModificacion)="row">
                    <div>
                      {{ row.item.fechaModificacion | formatoFechaCortaDMA }}
                    </div>
                  </template>
                  <template v-slot:cell(Acciones)="row" style="width: 200px">
                    <b-button size="sm" variant="warning" class=" mr-1 marginbotones "
                              style="border-radius:15px"
                              v-if="row.item.registroActivo && $localStorageService.can('Config_categoria_editar')"
                              v-b-tooltip.hover
                              title="Editar"
                              @click="modificar(row.item)"
                    >
                      <em class="editar_svg sm"></em>
                    </b-button>
                    <b-button size="sm" variant="outline-success" class=" mr-1 marginbotones "
                              style="border-radius:15px"
                              v-if="!row.item.registroActivo && $localStorageService.can('Config_categoria_activar')"
                              v-b-tooltip.hover
                              title="Activar característica"
                              @click="activarDesactivar(row.item)">
                      <em class="fa fa-undo"></em>
                    </b-button>

                    <b-button size="sm" variant="danger" class="mr-1 marginbotones paddingbotones"
                              v-else-if="$localStorageService.can('Config_categoria_activar')"
                              v-b-tooltip.hover
                              title="Desactivar característica"
                              @click="activarDesactivar(row.item)">
                      <em class="eliminar_svg icon-boton"></em>
                    </b-button>
                  </template>
                </b-table>


                <div align="center" v-if="loader">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <b-col v-else>
                  <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                </b-col>
              </b-col>
              <b-col v-if="!loader">
                <b-pagination
                    v-if="datosTabla !== undefined && datosTabla.length > 10"
                    align="center"
                    v-model="paginaActual"
                    :total-rows="datosTabla.length"
                    :per-page="registrosPorPagina"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>

        </b-row>
      </b-container>
    </b-card>

    <b-modal
        v-model="showModal"
        size="xl"
        class="redondeo"
        centered>
        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="descripcion">Descripcion
              </label>
              <validacion/>
              <b-input-group size="sm" class="mb-2">
                <b-form-input
                    class="redondeo"
                    id="descripcion"
                    name="descripcion"
                    placeholder="Descripcion"
                    v-model="$v.objGuardar.descripcionCaracteristica.$model"
                    :state="validateState('descripcionCaracteristica')"
                    required
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label for="descripcion">Categoria
              </label>
              <validacion/>
              <b-input-group size="sm" class="mb-2">
                <v-select
                    style="width: 100%"
                    v-model="$v.objGuardar.idCategoria.$model"
                    :options="listaCategorias"
                    label="descripcion"
                    placeholder="Selecciona una categoria"
                    :reduce="(item) => item.idCategoriaNuevo">
                </v-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>


      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">{{ tituloModal }}</div>
        </div>
      </template>

      <template #modal-footer="{ ok, cancel }">
        <div class="w-100 float-none text-center">
          <b-button class="mt-3 botonesAzulFuerte"
                    style="width:10%;margin:10px"
                    variant="primary"
                    :disabled="loaderAcciones"
                    @click="guardar"
          >
            Guardar
          </b-button>
          <b-button
              style="width:10%;margin:10px"
              class="mt-3 botonesGrisFuerte"
              :disabled="loaderAcciones"
              @click="cerrarModal()"
          >
            Cancelar
          </b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {required} from "vuelidate/lib/validators";

export default {
  name: "caracteristicasCategoria",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      filtro: {
        palabraClave: null,
      },
      loader: false,
      loaderAcciones: false,
      tituloModal: '',
      showModal: false,
      datosTabla: [],
      listaCategorias: [],
      fields: [
        {key: "idCaracteristica", label: "ID", sortable: true},
        {key: "descripcionCaracteristica", label: "Descripcion", sortable: true},
        {key: "descripcionCategoria", label: "Categoria", sortable: true},
        {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
        {key: "usuarioModificacion", label: "Usuario modificación", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 1,
      objGuardar: {
        idCaracteristica: null,
        descripcionCaracteristica: null,
        idCategoria: null,
        descripcionCategoria: null,
        registroActivo: null
      }
    }
  },
  validations: {
    objGuardar: {
      descripcionCaracteristica: {required},
      idCategoria: {required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerCaracteristicasCategoria();
    this.obtenerCategorias();
  },
  methods: {
    obtenerCaracteristicasCategoria() {
      this.loader = true;
      this.$http
          .post(this.$api + 'catalogo/caracteristicas/categoria/obtener', this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    obtenerCategorias() {
      this.$http
          .get(this.$api + 'categoriaNuevo/obtenerCategoriasNuevos/activos')
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaCategorias = respuesta.data.data;
            }
          });
    },
    agregar() {
      this.tituloModal = 'Crear característica';
      this.showModal = true;
    },
    cerrarModal() {
      this.showModal = false;
      this.limpiar()
    },
    modificar(item) {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.objGuardar = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar característica';
      this.showModal = true;
    },
    activarDesactivar(item) {
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la característica?' : '¿Está seguro de activar la característica?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.loader = true;
          this.$http.post(this.$api + 'catalogo/caracteristicas/categoria/activarDesactivar', item.idCaracteristica).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La característica se actualizó correctamente",
                  });
                }
              }
          ).finally(() => {
            this.loader = false
          })
        }
      })
    },
    guardar() {
      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        return;
      }

      this.loader = true;
      this.loaderAcciones = true;
      this.$http.post(this.$api + 'catalogo/caracteristicas/categoria/guardar', this.objGuardar).then(respuesta => {
            if (respuesta.data.data) {
              this.filtro.palabraClave = this.objGuardar.descripcion;
              this.showModal = false;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "La característica se guardó correctamente"
              });
              this.obtenerCaracteristicasCategoria();
              this.limpiar();
            }
          }
      ).catch(error => {
        console.error(error.message)
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: error.message,
        });
      }).finally(() => {
        this.loader = false;
        this.loaderAcciones = false;
      })
    },
    limpiar() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.objGuardar = {
        idCaracteristica: null,
        descripcionCaracteristica: null,
        idCategoria: null,
        descripcionCategoria: null,
        registroActivo: null
      }
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
</style>